import styled from 'styled-components';

export const ProfileDetailsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 1100px;
  width: 100%;

  h1 {
    color: ${(props) => props.theme.white.string()};
  }
`;
